import React, { Component } from "react";
import BookList from "../booklist/BookList";

export default class Home extends Component {
    constructor() {
      super()
    }
    render(){
        const {location, library, chooseBook, theme } = this.props
        return (
            <div>
            <h1 style={{ marginLeft:"110px", fontSize: "2.8em", fontFamily: "Helvetica"}}> Κeimelia Publications </h1>
                <BookList location={location}
                library={library}
                chooseBook={chooseBook}
                theme={theme}/>
                <div style={{ 
                    width:"100vw",
                    paddingLeft: "30px",
                    fontSize: "14px", 
                    height: "100px",
                    display: "flex",
                    alignItems: "flex-end",
                    position: "absolute", 
                    bottom: "0px", 
                    left: "80px"}}>
                 
                    <span>contact@keimelia.com </span>
                    </div>
            </div>
        )

    }
}

//   ..<a href="https://www.w3schools.com" style={{textDecoration: "none"}}> acca</a>


// WEBPACK FOOTER //
// ./src/containers/dash/Dash.js